<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <AcknowledgementsOneFormFields></AcknowledgementsOneFormFields>
        <AcknowledgementsTwoFormFields></AcknowledgementsTwoFormFields>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import AcknowledgementsOneFormFields from './acknowledgements/AcknowledgementsOneFormFields.vue'
import AcknowledgementsTwoFormFields from './acknowledgements/AcknowledgementsTwoFormFields.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

const checkAll = computed({
    get() {
        return (
            account.compliance_profiles.esac.acknowledgements.currency_change_risk &&
            account.compliance_profiles.esac.acknowledgements.own_account &&
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering &&
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement &&
            account.compliance_profiles.esac.acknowledgements.report_changes &&
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information &&
            account.compliance_profiles.esac.acknowledgements.self_certification_form
        )
    },
    // setter
    set(newValue) {
        if (newValue) {
            account.compliance_profiles.esac.acknowledgements.currency_change_risk = true
            account.compliance_profiles.esac.acknowledgements.own_account = true
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering = true
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement = true
            account.compliance_profiles.esac.acknowledgements.report_changes = true
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information = true
            account.compliance_profiles.esac.acknowledgements.self_certification_form = true
        } else {
            account.compliance_profiles.esac.acknowledgements.currency_change_risk = false
            account.compliance_profiles.esac.acknowledgements.own_account = false
            account.compliance_profiles.esac.acknowledgements.anti_money_laundering = false
            account.compliance_profiles.esac.acknowledgements.tax_data_exchange_agreement = false
            account.compliance_profiles.esac.acknowledgements.report_changes = false
            account.compliance_profiles.esac.acknowledgements.complete_and_correct_information = false
            account.compliance_profiles.esac.acknowledgements.self_certification_form = false
        }
    },
})

initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('acknowledgements'))
</script>

<style scoped></style>
